import { FC } from 'react';

import LOCALE from 'common/locale';
import Heading, { HeadingProps } from 'components/_core/Heading';

import { PriceProps } from './index';
import locales from './locales';

type RebrandedPriceProps = Pick<PriceProps, 'value' | 'withoutCents'> &
  Omit<HeadingProps, 'variant'> & {
    size?: '3xl' | '2xl' | 'xl' | 'lg' | 'md' | 'sm';
    showExcludingVat?: boolean;
    showIncludingVat?: boolean;
  };
const RebrandedPrice: FC<RebrandedPriceProps> = ({
  showExcludingVat,
  showIncludingVat,
  value,
  withoutCents = false,
  ...rest
}) => {
  const formatter = new Intl.NumberFormat(LOCALE, {
    currency: 'EUR',
    minimumFractionDigits: withoutCents ? 0 : undefined,
    style: 'currency',
  });

  const price = formatter.format(value);

  return (
    <Heading size="xl" variant="number" {...rest}>
      {price}
      {showExcludingVat ? ` ${locales.excludingVAT}` : null}
      {showIncludingVat ? ` ${locales.includingVAT}` : null}
    </Heading>
  );
};

export default RebrandedPrice;
